import actManager from './act/manager';
import kvManager from './kv/manager';
import transitionManager from './transition';
import fixedChange from './fixedChange';
import effectManager from '../module/effect';
import mousePararax from '../module/mouse/pararax';

let effect = new effectManager();

export default class topManager {
    constructor(ua) {

        this.ua = ua;

        this.w;
        this.h;

        this.current = 0;
        this.prevCurrent = 0;

        this.kv = new kvManager(ua);
        this.act = new actManager(ua);
        this.fixed = new fixedChange(ua);
        this.fixedColor = ["black","white","white","white","black","black"];

        this.status = {
            splashFlg : false,/* スプラッシュが完了しているかを受け取る */
            contFlg : { /* コンテンツを消したかどうか管理 */
                kv : false,
                kvImg : false,
                section :{
                    1 : false,
                    2 : false,
                    3 : false,
                    4 : false,
                    5 : false,
                },
                sectionMotionFlg : false, /* アニメーション開始と終了を監視 */
            },
            act : { /* app.jsに引き継ぐactセンテンスのステータス */
                flg : false, /* 詳細が開いているか */
                select :{
                  day : 0
                },
                fixbtn : {
                    fit : false, /* アーティスト詳細を開いてボタンの位置が固定になっているか？ */
                    size : {
                        full : 0,
                        half : 0
                    }
                }
            },
            kvShowTimer : "", /* KV用のタイマー */
        }

        this.$kv = $("#p-kv");
        this.$kvInfo = $("#p-kv-info >*");

        this.$section = {
            1 : $("#p-theme"),
            2 : $("#p-act"),
            3 : $("#p-ticket"),
            4 : $("#p-live"),
            5 : $("#p-report")
        };

        if(Useragnt.pc) this.themePara = new mousePararax(this.$section[1]);
        if(Useragnt.pc) this.ticketPara = new mousePararax(this.$section[3]);
        if(Useragnt.pc) this.reportPara = new mousePararax(this.$section[5]);

        this.transition = new transitionManager(ua);

    }
    init(){

        this.kv.init();
        this.act.init();

    }
    render(mouse,currentSection,scrollInc,fpsRate){

        this.current = currentSection;
        this.act.render(mouse,this.current,scrollInc,fpsRate);


        if(this.current!==this.prevCurrent){

            if(!this.status.contFlg.section[this.current]){

                let _this = this;
                this.act.status.sectionMotionFlg = false;

                if(this.current!==0){
                    this.status.contFlg.section[this.current] = true;
                    this.transition.show(this.$section[this.current]);
                    if(this.current===1)this.$section[this.current].addClass("is-current")
                }

                setTimeout(()=> {
                    _this.fixed.color(_this.fixedColor[_this.current],_this.current);
                    _this.fixed.pager(_this.current);
                    setTimeout(()=>_this.act.status.sectionMotionFlg = true,2e3)
                },3e2);
            }


            if(this.status.contFlg.section[this.prevCurrent]&&this.prevCurrent!==0){
                this.status.contFlg.section[this.prevCurrent] = false;
                this.transition.out(this.$section[this.prevCurrent],this.$section[this.current]);
            }

            this.prevCurrent = this.current;

        }

        /* KV以外の分岐 */


        if(this.current===0){
            if(this.status.contFlg.kv){
                this.status.contFlg.kv = false;
                let _this = this;

                TweenMax.killChildTweensOf(this.$kv.find(".js__splash-splittext,#p-kv-info"));
                this.kvShowTimer = setTimeout(function () {
                    effect.splitTextKV(_this.$kv.find(".js__splash-splittext >* >*"),"show");
                    effect.opacity(_this.$kvInfo,"show");
                    _this.transition.out(_this.$section[1]);
                },1e3);
                this.status.contFlg.section[1] = false;
                this.transition.out(this.$section[1]);
                this.$section[1].removeClass("is-current")

            }

        }else{
            if(!this.status.contFlg.kv){
                this.status.contFlg.kv = this.status.contFlg.kvImg = true;
                //this.$kv
                // TweenMax.killChildTweensOf($("#p-kv .js__splash-splittext,#p-kv-info"));
                TweenMax.killChildTweensOf(this.$kv.find(".js__splash-splittext,#p-kv-info"));
                clearTimeout(this.kvShowTimer);
                effect.splitTextKV(this.$kv.find(".js__splash-splittext >* >*"),"out");
                effect.opacity(this.$kvInfo,"out");
            }

        }


        /* センテンスごとの分岐 */


        this.fixed.changeCnt(this.current);
        switch (this.current){
            case 0 :
                this.kv.render(mouse);
                this.status.splashFlg = this.kv.status.comp;
                if(this.transition.status.darkbg) this.transition.darkbgOut();
                if(!this.kv.status.kvbg) this.kv.show();
                break;
            case 1 :
                if(!this.transition.status.darkbg) this.transition.darkbgShow();
                this.kv.render(mouse);
                if(Useragnt.pc&&fpsRate<2) this.themePara.render(mouse);
                break;
            case 2 :
                if(!this.transition.status.darkbg) this.transition.darkbgShow();
                if(this.kv.status.kvbg&&Useragnt.android) this.kv.out();

                /* app.jsでマウスの加減速しているmoduleに渡すため */
                this.status.act.flg = this.act.status.selected;
                this.status.act.fixbtn.fit = this.act.status.fixbtn.fit;
                this.status.act.fixbtn.size.full = this.act.status.fixbtn.size.full;
                this.status.act.fixbtn.size.half = this.act.status.fixbtn.size.half;
                this.status.act.select.day = this.act.status.select.day;

                break;
            case 3 :
                if(Useragnt.pc&&fpsRate<2) this.ticketPara.render(mouse);
                if(!this.transition.status.darkbg) this.transition.darkbgShow();
                // if(!this.kv.status.kvbg) setTimeout(()=> this.kv.show(),3e2)
                if(!this.kv.status.kvbg) this.kv.show()
                break;
            case 4 :
                if(this.kv.status.kvbg) this.kv.out();
                if(this.transition.status.darkbg) this.transition.darkbgOut();
                break;
            case 5 :
                if(Useragnt.pc&&fpsRate<2) this.reportPara.render(mouse);
                if(this.transition.status.darkbg) this.transition.darkbgOut();
                if(this.kv.status.kvbg) this.kv.out();
                break;
        }


    }
    resize(w,h){

        this.w = w;
        this.h = h;

        this.kv.resize(w);
        if(Useragnt.pc) this.themePara.resize(w);
        if(Useragnt.pc) this.ticketPara.resize(w);
        if(Useragnt.pc) this.reportPara.resize(w);
        this.act.resize(w,h);

    }
}